import React, { useState } from 'react';
import ProductDetail from './ProductDetail';
import './ProductCard.css';

function ProductCard({ producto }) {
  const [showDetail, setShowDetail] = useState(false);

  const getCantidadBadge = () => {
    if (!producto.cantidad) return null;
    
    if (producto.cantidad <= 2) {
      return <span className="cantidad-badge pocas">¡Solo {producto.cantidad}!</span>;
    } else if (producto.cantidad <= 5) {
      return <span className="cantidad-badge medias">{producto.cantidad} unidades</span>;
    } else {
      return <span className="cantidad-badge muchas">{producto.cantidad} unidades</span>;
    }
  };

  return (
    <>
      <div className="product-card" onClick={() => setShowDetail(true)}>
        <div className="product-image">
          {producto.imageURLs && producto.imageURLs[0] ? (
            <img src={producto.imageURLs[0]} alt={producto.modelo} />
          ) : (
            <div className="no-image">📱</div>
          )}
          
          <div className="badges">
            {producto.disponible ? (
              <span className="badge disponible">Disponible</span>
            ) : (
              <span className="badge no-disponible">No disponible</span>
            )}
            {getCantidadBadge()}
          </div>
        </div>

        <div className="product-info">
          <h3>{producto.marca} {producto.modelo}</h3>
          <p className="product-specs">
            {producto.almacenamiento} • {producto.color}
          </p>
          <p className="product-price">L {producto.precio.toLocaleString('es-HN')}</p>
          <p className="product-estado">{producto.estado}</p>
        </div>
      </div>

      {showDetail && (
        <ProductDetail 
          producto={producto} 
          onClose={() => setShowDetail(false)} 
        />
      )}
    </>
  );
}

export default ProductCard;